var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bu10-container"},[_c('sensorView',{attrs:{"sensorList":_vm.sensorList,"realDataObj":_vm.realDataObj}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }